import { render, staticRenderFns } from "./profile-user-info.vue?vue&type=template&id=7278cae0&"
import script from "./profile-user-info.vue?vue&type=script&lang=js&"
export * from "./profile-user-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports